
import { Carousel, Slide, } from 'vue-carousel';
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/account/store';
import { SliderItem, } from '~/utils/models';

@Component({
	components: {
		Carousel,
		Slide,
	},
})
export default class SliderCarousel extends Vue {

	@Prop({
		type: Array,
		required: true,
	})
	slides!: readonly SliderItem[];

	@Prop({
		type: Number,
		required: false,
		default: 5000,
	})
	autoIntervalSpeed!: number;

	@Prop({
		required: false,
	})
	isDisplayNewFeature!: boolean;

	sliderValue: null | number = null;
	isAutoplay = true;

	handleFocus(index:number) {
		if (!this.isDisplayNewFeature) {
			this.sliderValue = index <= 2 ? 0 : null;
			this.isAutoplay = false;
		}
	}

	handleBlur() {
		this.isAutoplay = true;
		if (this.sliderValue === 0 || null) {
			this.sliderValue = null;
		}
	}

	closeOverlay() {
		if (this.isDisplayNewFeature) {
			Store.commit.closeOverlay();
		}
	}
}
